<template>
  <div class="device-card">
    <img :src="imageUrl" alt="Device Image" />
    <div class="device-info">
      <h3>{{ deviceName }}</h3>
      <p>Model: {{ model }}</p>
      <p>Status: {{ status }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceCard',
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    deviceName: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.device-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  width: 270px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  img {
    width: 100%;
    height: auto;
    border-radius: 8px 8px 0 0;
  }

  .device-info {
    margin-top: 16px;
  }

  h3 {
    margin: 0;
    font-size: 1.5em;
  }

  p {
    margin: 8px 0;
    font-size: 1em;
    color: #666;
  }
}
</style>